import React, { lazy, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import DashboardHeader from "../section/DashboardHeader";
import DashboardMenu from "../section/DashboardMenu";
import { useSelector } from "react-redux";
import LoaderComponent from "../loader/LoaderComponent";

const FooterSection = lazy(() => import("../../component/layout/footer"));

export default function DashboardContainer({ setIsMainFooter }) {
  const isFooter =
    window?.location?.pathname?.includes("/dashboard") ||
    window?.location?.pathname?.includes("/volunteer") ||
    window?.location?.pathname?.includes("/admin");
  if (isFooter) {
    setIsMainFooter(false);
  }
  const isLoading = useSelector((state) => state.loading.isLoading);
  return (
    <div id="dashboard" className="d-flex">
      <DashboardMenu />
      <div className="w-100" style={{ overflow: "auto" }}>
        <DashboardHeader />
        <div style={{ minHeight: "90vh" }} className="bg-dashboard pb-50">
          <Outlet />
          {isLoading ? <LoaderComponent /> : null}
        </div>
        <FooterSection />
      </div>
    </div>
  );
}
